import { render, staticRenderFns } from "./UserFooter.vue?vue&type=template&id=b675a714&scoped=true&"
var script = {}
import style0 from "./UserFooter.vue?vue&type=style&index=0&id=b675a714&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b675a714",
  null
  
)

export default component.exports